<script setup lang="ts">
	import { type ClassNameValue } from 'tailwind-merge'

	interface Props {
		count: number
		activeCls?: ClassNameValue
		dotClass?: ClassNameValue
	}
	const current = defineModel<number>({ default: 0 })
	const emit = defineEmits<{
		(e: 'change', param: number): void
	}>()
	const indiccator = useTemplateRef('indicator')

	defineExpose({
		indiccator
	})
	const { activeCls = 'w-[18px] bg-[#3F8D7F]' } = defineProps<Props>()
</script>

<template>
	<ul ref="indicator" class="flex items-center justify-center gap-1 flex-wrap">
		<li
			v-for="(_, index) in count"
			:key="index"
			:class="
				cn(
					'rounded-full h-1 shrink-0 custom-transition origin-center flex-none',
					dotClass,
					index === current ? activeCls : ''
				)
			"
			@click="() => [(current = index), emit('change', index)]"
		/>
	</ul>
</template>
